<template>
  <base-page-layout title="Consultar benefícios">
    <mf-button label="Voltar" color="marca-0-l40" icon="arrow_back" icon-position="left" text @click="goBack" />
    <div class="d-flex flex-column justify-center align-center my-2 mx-4">
      <span class="gray-title ma-2">Cashback</span>
      <span class="gray-subtitle mx-3">Entre com os dados para identificar o consumidor e o período que deseja consultar.</span>

      <form class="d-flex flex-column ma-6 responsive-width">
        <v-radio-group v-model="searchConsumerFor" mandatory>
          <template v-slot:label>
            <div>Buscar consumidor por:</div>
          </template>
          <v-radio label="Documento" value="document"></v-radio>
          <v-radio label="Telefone" value="phone"></v-radio>
        </v-radio-group>

        <label class="cinza-0-text">{{ consumerLabel }}</label>
        <v-text-field
          v-model="consumer"
          v-mask="inputMask"
          :error-messages="consumerErrors"
          :placeholder="consumerPlaceholder"
          required
          outlined
          background-color="white"
          :disabled="loading"
          @keydown.enter="submit"
          @input="$v.consumer.$touch()"
          @blur="$v.consumer.$touch()"
        />

        <label class="cinza-0-text">Período:</label>
        <div class="mb-10" style="background-color: white; height: 56px">
          <mf-date-range-picker
            outlined
            placeholder="Selecionar período"
            :initial-date.sync="startDate"
            :final-date.sync="endDate"
            :disabled="loading"
            :max="maxDate"
            :error="dateError.length > 0"
            :error-messages="dateError"
            disable-typing
            @change="() => (dateError = [])"
          />
        </div>

        <mf-button
          class="mt-8 align-self-center"
          size="lg"
          :loading="loading"
          :disabled="loading || disabledSubmit"
          color="marca-0-l40"
          label="Buscar"
          icon="arrow_forward"
          icon-position="right"
          @click="submit"
        />
      </form>
    </div>
    <select-consumer-dialog ref="consumerDialog" :consumers="consumers" @selectConsumer="goToResults" />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { required, minLength } from 'vuelidate/lib/validators'
import { DateTime } from 'luxon'
import { QUERY_USERS_WITH_TEMP } from '../../graphql'
import SelectConsumerDialog from '@/modules/clientes/consultar-ofertas/views/components/SelectConsumerDialog.vue'

export default {
  components: {
    BasePageLayout,
    SelectConsumerDialog,
  },
  data: () => ({
    loading: false,
    consumer: '',
    searchConsumerFor: 'document',
    startDate: DateTime.now().minus({ months: 1 }).toISODate(),
    endDate: DateTime.now().toISODate(),
    dateError: [],
    consumers: [],
  }),
  computed: {
    consumerErrors() {
      const errors = []
      if (!this.$v.consumer.$dirty) return errors
      !this.$v.consumer.required && errors.push('Preencha o campo com CPF, CNPJ ou telefone')
      !this.$v.consumer.minLength && errors.push('CPF, CNPJ ou telefone inválido')
      return errors
    },
    maxDate() {
      return DateTime.now().toISODate()
    },
    inputMask() {
      if (this.searchConsumerFor === 'phone') return ['(##) #####-####']
      else return ['###.###.###-##', '##.###.###/####-##']
    },
    consumerLabel() {
      if (this.searchConsumerFor === 'phone') return 'Telefone:'
      else return 'Documento consumidor:'
    },
    consumerPlaceholder() {
      if (this.searchConsumerFor === 'phone') return 'Número do telefone'
      else return 'CPF ou CNPJ'
    },
    disabledSubmit() {
      if (this.$v.$invalid) return true
      if (!this.startDate || this.startDate.length <= 0 || !this.endDate || this.endDate.length <= 0) {
        return true
      }
      return false
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'consultar-ofertas' })
    },
    clearErrors() {
      this.dateError = []
    },
    invalidInput() {
      this.clearErrors()
      let error = false
      this.$v.$touch()
      if (this.$v.$invalid) error = true
      if (!this.startDate || this.startDate.length <= 0 || !this.endDate || this.endDate.length <= 0) {
        this.dateError.push('Período é obrigatório')
        error = true
      }
      return error
    },
    async submit() {
      if (this.invalidInput()) return

      this.loading = true
      try {
        const result = await this.$apollo.query({
          query: QUERY_USERS_WITH_TEMP,
          fetchPolicy: 'no-cache',
          variables: {
            search: this.onlyNumbers(this.consumer),
          },
          context: {
            uri: this.$microservicesUrls['consumer'],
          },
        })
        this.consumers = result.data.usersWithTemp
        if (this.consumers.length === 1) {
          this.goToResults(this.consumers[0])
        } else {
          this.$refs.consumerDialog.selectConsumerDialog = true
        }
      } catch (err) {
        console.log(err)
        this.$snackbar({ message: 'Erro ao buscar consumidor', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    onlyNumbers(string) {
      return string.replace(/\D/g, '')
    },
    goToResults(consumerSelected) {
      this.$router.push({
        name: 'consultar-cashback-resultado',
        params: {
          c: consumerSelected,
          sd: this.startDate,
          ed: this.endDate,
        },
      })
    },
  },
  validations: {
    consumer: { required, minLength: minLength(11) },
  },
}
</script>

<style lang="scss" scoped>
.gray-title {
  color: $cinza-d20;
  font-size: 22px;
  line-height: 26.4px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  text-align: center;
}

.gray-subtitle {
  color: $cinza-d10;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.4px;
  text-align: center;
}

.cinza-0-text {
  color: $cinza-0;
}

.responsive-width {
  width: 40%;
}

@media screen and (max-width: 933px) {
  .responsive-width {
    width: 100%;
  }
}
</style>
